import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROLE_LANDING } from '../navigation/screens';
import { ProtoRole } from '../models/domain.models';
import { SessionContextService } from './session-context.service';

/** Allows the route when the session role is in `data.roles`; otherwise sends the user to their landing. */
export const roleGuard: CanActivateFn = route => {
  const session = inject(SessionContextService);
  const router = inject(Router);
  const allowed = (route.data['roles'] ?? []) as ProtoRole[];
  const role = session.role();
  if (role && allowed.includes(role)) return true;
  return router.createUrlTree([role ? ROLE_LANDING[role] : '/login']);
};

/** A person in several trees has to choose one (P-03) before any screen of the shell. */
export const treeChosenGuard: CanActivateFn = () => {
  const session = inject(SessionContextService);
  const router = inject(Router);
  return session.treePending() ? router.createUrlTree(['/elegir-arbol']) : true;
};

export const landingGuard: CanActivateFn = () => {
  const session = inject(SessionContextService);
  const router = inject(Router);
  const role = session.role();
  return router.createUrlTree([role ? ROLE_LANDING[role] : '/login']);
};
